/** Service Desk console: ang mga screen ng engineer sa telepono (C23: My day, visit, check-in, checklist, sukat at piyesa, litrato, pirma, tapos na), SD-S3-11. */
export const serviceField = {
  title: "Ang araw ko",
  back: "Bumalik",
  loading: "Kinukuha ang mga visit mo",
  refresh: "I-refresh",
  retry: "Subukan ulit",
  noOrganisation: "Walang organisasyon",
  noWindow: "Walang oras pa",
  todayList: "Mga visit ngayon",
  forbiddenTitle: "Para ito sa mga field engineer",
  forbiddenBody: "Hindi pwedeng gumawa ng visit sa telepono ang role mo. Hilingin sa admin ng workspace na ibigay sa iyo ang Field engineer role.",
  nav: { label: "App ng engineer", entry: "Ang araw ko", myDay: "Ang araw ko", visit: "Visit", checklist: "Checklist", parts: "Piyesa", photos: "Litrato" },
  tabs: { label: "Araw", today: "Ngayon", upcoming: "Susunod" },
  empty: {
    title: "Walang naka-assign na visit",
    body: "Lalabas dito ang mga visit na naka-schedule para sa iyo pagka-book ng opisina.",
    todayTitle: "Walang visit ngayon",
    todayBody: "Mag-relax ka muna. Lalabas dito ang mga bagong visit pagka-schedule.",
    upcomingTitle: "Wala pang susunod",
    upcomingBody: "Nakalista rito ang mga visit na naka-book sa mga susunod na araw.",
  },
  dayError: { title: "Hindi makuha ang araw mo", body: "Tingnan ang koneksyon mo at subukan ulit. Walang nabago.", saved: "Walang koneksyon: ipinapakita ang mga visit na naka-save sa telepono." },
  error: { title: "Hindi makuha ang visit na ito", body: "Tingnan ang koneksyon mo at subukan ulit. Walang nabago." },
  visit: { title: "Visit", notFoundTitle: "Hindi nahanap ang visit", notFoundBody: "Maaaring hindi na ito naka-assign sa iyo." },
  connection: {
    online: "Online",
    offlineChip: "Offline",
    offline: "Offline ka. Naka-save sa telepono ang report mo at ipapadala ito pagbalik ng network.",
    offlinePending_one: "Offline ka. {{count}} item ang naghihintay at ipapadala pagbalik ng network. Naka-save sa telepono ang report mo.",
    offlinePending_other: "Offline ka. {{count}} item ang naghihintay at ipapadala pagbalik ng network. Naka-save sa telepono ang report mo.",
    sending_one: "Ipinapadala ang {{count}} item…",
    sending_other: "Ipinapadala ang {{count}} item…",
    failed_one: "Hindi naipadala ang {{count}} item.",
    failed_other: "Hindi naipadala ang {{count}} item.",
    retry: "Subukan ulit",
  },
  leave: {
    title: "Aalis kahit may naghihintay na item?",
    body_one: "{{count}} item pa ang naghihintay na maipadala. Kapag umalis ka sa pahinang ito, maaari itong mawala.",
    body_other: "{{count}} item pa ang naghihintay na maipadala. Kapag umalis ka sa pahinang ito, maaari silang mawala.",
    confirm: "Umalis pa rin",
  },
  job: { queued: "Naka-pila", sending: "Ipinapadala…", retrying_one: "Sinusubukan ulit (pagsubok {{count}})", retrying_other: "Sinusubukan ulit (pagsubok {{count}})", waitingNetwork: "Naghihintay ng network", failed: "Hindi naipadala", retry: "Subukan ulit", discard: "Alisin" },
  save: {
    clean: "Naka-save na ang lahat.",
    saved: "Na-save noong {{time}}",
    saving: "Sine-save…",
    dirty: "Hindi pa naka-save. Nagse-save tuwing 10 segundo.",
    offline: "Offline: naka-save sa telepono, ipapadala pagbalik ng network.",
    error: "Hindi ma-save. Susubukan ulit; nakatabi sa telepono ang isinulat mo.",
  },
  gate: {
    checkInFirst: "Mag-check in muna. Bubukas ang report kapag nasa site ka na.",
    ended: "Tapos na ang visit na ito kaya hindi na mababago ang report.",
    openVisit: "Buksan ang visit",
    openSummary: "Buksan ang buod",
  },
  brief: {
    client: "Kliyente",
    equipment: "Kagamitan",
    ticket: "Ticket",
    bring: "Dalhin at ihanda",
    prep: "Inihanda para sa kliyente",
    travel: "Pagpunta roon",
    internal: "Tala ng opisina",
    checklist: "Checklist",
    items_one: "{{count}} item",
    items_other: "{{count}} item",
    access: "Pasukan",
    contact: "Kontak",
    navigate: "Mag-navigate",
    call: "Tawagan si {{name}}",
    noPhone: "Walang numero ng telepono ang kontak na ito.",
    warranty: { in_warranty: "Sakop ng warranty", expiring: "Malapit nang matapos ang warranty", expired: "Wala nang warranty", unknown: "Hindi alam ang warranty" },
    checkIn: "Mag-check in",
    onMyWay: "Papunta na ako",
    enRouteSent: "Nakikita na ng opisina na papunta ka na.",
    checkedIn: "Nag-check in noong {{time}}.",
    checkedInPending: "Nag-check in noong {{time}}. Naghihintay ng network para maipadala.",
    checkInFailed: "Hindi ito gumana. Subukan ulit.",
    continue: "Ituloy ang visit",
    summary: "Buksan ang buod",
    shareLocation: "Ibahagi ang lokasyon ko kapag nag-check in at out",
    shareLocationHint: "Magaspang lang, hanggang 3 decimal, hindi makikita ng kliyente. Isang beses lang itatanong sa pagpindot.",
    noAccess: "Walang pumapasok sa akin",
  },
  noAccess: { title: "Walang nagpapasok sa iyo?", body: "Sabihin sa opisina kung bakit. May follow-up na visit na maghihintay sa pila.", confirm: "I-report na walang access" },
  cannotComplete: { title: "Hindi mo natapos?", body: "Sabihin kung ano ang kulang (piyesa, kagamitan, access). Magiging Awaiting parts ang ticket.", confirm: "Tapusin ang visit" },
  reason: { label: "Dahilan", tooShort: "Sumulat ng kahit {{min}} character." },
  onSite: {
    title: "Nasa site",
    timeOnSite: "Oras sa site",
    checkedInAt: "Nag-check in {{time}}",
    notCheckedIn: "Hindi pa naka-check in",
    checklistNote: "{{done}} sa {{total}} ang nasagot",
    measuresParts: "Sukat at piyesa",
    partsNote_one: "{{count}} piyesa",
    partsNote_other: "{{count}} piyesa",
    photosNote_one: "{{count}} litrato, {{pending}} ang naghihintay",
    photosNote_other: "{{count}} litrato, {{pending}} ang naghihintay",
    work: "Ginawang trabaho",
    workHint: "Kailangan ito para makumpleto ang visit.",
    findings: "Natuklasan",
    finish: "Tapusin at kumuha ng pirma",
    cannotFinish: "Hindi ko natapos ang trabaho",
  },
  checklist: {
    pass: "Pasado",
    fail: "Bagsak",
    na: "N/A",
    progress: "{{pass}}/{{total}} pasado",
    answered: "{{done}} sa {{total}} ang nasagot",
    remaining_one: "{{count}} item ang walang sagot. Kailangan ng resulta ang bawat item bago makumpleto ang visit.",
    remaining_other: "{{count}} item ang walang sagot. Kailangan ng resulta ang bawat item bago makumpleto ang visit.",
    markAll: "Markahan lahat na pasado",
    next: "Susunod: mga sukat",
    noteFor: "Tala para sa {{item}}",
    notePlaceholder: "Ano ang nakita mo?",
    emptyTitle: "Walang checklist ang visit na ito",
    emptyBody: "Walang template ang visit na ito kaya walang ita-tick. Ilarawan na lang ang ginawa.",
  },
  measures: { title: "Sukat at piyesa", next: "Susunod: litrato" },
  measurements: {
    title: "Mga sukat",
    none: "Wala pang sukat.",
    add: "Magdagdag ng sukat",
    name: "Pangalan ng sukat {{n}}",
    value: "Halaga ng sukat {{n}}",
    unit: "Yunit ng sukat {{n}}",
    namePlaceholder: "Resistivity pagkatapos",
    valuePlaceholder: "18.2",
    unitPlaceholder: "MΩ·cm",
    remove: "Alisin ang sukat {{n}}",
  },
  parts: {
    title: "Mga piyesang ginamit",
    none: "Wala pang piyesang ginamit.",
    addPart: "Magdagdag ng piyesa",
    sheetTitle: "Magdagdag ng piyesang ginamit",
    sheetBody: "Piliin sa catalogue o i-type, tapos sabihin kung sino ang magbabayad.",
    part: "Piyesa",
    partHint: "Mag-type ng kahit 2 letra para maghanap sa catalogue.",
    suggestions: "Mga tugma sa catalogue",
    noCatalogue: "Hindi available ang catalogue. I-type ang pangalan ng piyesa.",
    noMatch: "Walang tugma sa catalogue. Gamitin ang tinype mo.",
    catalogueError: "Hindi makahanap sa catalogue. I-type ang pangalan ng piyesa.",
    freeText: "Gumamit ng sariling teksto",
    quantity: "Dami",
    coverage: "Sino ang magbabayad",
    choose: "Pumili",
    coverageOptions: { warranty: "Warranty", contract: "Kontrata", chargeable: "Sisingilin" },
    removedSerial: "Serial na tinanggal",
    newSerial: "Bagong serial",
    asset: "Ikinabit sa",
    assetHint: "Magdadagdag ng entry na napalitan ang piyesa sa history ng kagamitan.",
    noAsset: "Hindi nakakabit sa kagamitan",
    add: "Idagdag ang piyesa",
    added: "Naidagdag ang {{part}}",
    remove: "Alisin ang {{part}}",
    out: "labas",
    in: "pasok",
    errors: { description: "Pangalanan ang piyesa.", quantity: "Maglagay ng buong numero mula 1 hanggang 999.", coverage: "Piliin kung sino ang magbabayad: warranty, kontrata o sisingilin." },
  },
  time: {
    title: "Oras sa visit na ito",
    none: "Wala pang naitalang oras.",
    addTime: "Magdagdag ng oras",
    sheetTitle: "Magdagdag ng oras",
    sheetBody: "Oras sa site, biyahe o remote na trabaho para sa visit na ito.",
    minutes: "Minuto",
    minutesError: "Maglagay ng buong minuto mula 1 hanggang 1440.",
    quick: "Mabilis na halaga",
    activity: "Anong uri ng oras",
    activities: { remote: "Remote", travel: "Biyahe", on_site: "Nasa site", admin: "Admin" },
    billable: "Sisingilin",
    billableChip: "Sisingilin",
    note: "Tala",
    add: "Idagdag ang oras",
    added: "Naidagdag ang oras",
    remove: "Alisin ang {{time}}",
    hourShort: "oras",
    minuteShort: "min",
  },
  photos: {
    count_one: "{{count}} litrato",
    count_other: "{{count}} litrato",
    list: "Mga litrato ng visit na ito",
    emptyTitle: "Wala pang litrato",
    emptyBody: "Kumuha ng litrato ng kagamitan, ng trabaho at ng resulta. Sine-save muna ang mga ito sa telepono.",
    take: "Kumuha ng litrato",
    choose: "Pumili sa gallery",
    full: "Hanggang {{max}} litrato lang ang isang visit.",
    clientVisible: "Ipakita ang mga bagong litrato sa report ng kliyente",
    clientVisibleHint: "Naka-off: opisina lang ang makakakita.",
    queued_one: "{{count}} litrato ang naka-save sa telepono at ipinapadala",
    queued_other: "{{count}} litrato ang naka-save sa telepono at ipinapadala",
    notImage: "Hindi litrato ang {{name}}.",
    uploaded: "Na-upload",
    inReport: "Nasa report ng kliyente",
    remove: "Alisin ang {{name}}",
    removeTitle: "Alisin ang litratong ito?",
    removeBody: "Aalisin ito sa visit at buburahin ang file nito.",
    removeConfirm: "Alisin ang litrato",
    note: "Walang mawawala habang bukas ang pahinang ito. Kapag aalis ka na may naghihintay na litrato, hihingi ito ng kumpirmasyon.",
    pending_one: "{{count}} ang naghihintay",
    pending_other: "{{count}} ang naghihintay",
    allUploaded: "Na-upload na ang lahat ng litrato",
    notSent_one: "{{count}} litrato ang hindi naipadala",
    notSent_other: "{{count}} litrato ang hindi naipadala",
    next: "Susunod: pirma",
  },
  sign: {
    title: "Pirma ng kliyente",
    clear: "Burahin",
    summary: "Checklist {{pass}}/{{total}} pasado, {{parts}} piyesa, {{photos}} litrato.",
    cannotComplete: "Hindi pa makukumpleto ang visit",
    workMissing: "Ilarawan ang ginawang trabaho.",
    openNotes: "Buksan ang mga tala",
    checklistMissing_one: "{{count}} item sa checklist ang walang sagot.",
    checklistMissing_other: "{{count}} item sa checklist ang walang sagot.",
    openChecklist: "Buksan ang checklist",
    offline: "Offline ka. Kinukumpleto ng pirma ang visit sa server kaya kumonekta muna. Walang nawawala sa isinulat mo.",
    waitingActions_one: "{{count}} item (check-in, piyesa o oras) ang kailangang mauna sa server. Ipinapadala na ito.",
    waitingActions_other: "{{count}} item (check-in, piyesa o oras) ang kailangang mauna sa server. Ipinapadala na ang mga ito.",
    fixFirst: "Ayusin muna ang mga item sa itaas, saka makakapirma ang kliyente.",
    photosPending_one: "{{count}} litrato ang ina-upload pa. Mapupunta ito sa visit pagdating, pero wala ito sa report na ito.",
    photosPending_other: "{{count}} litrato ang ina-upload pa. Mapupunta ang mga ito sa visit pagdating, pero wala sila sa report na ito.",
    outcome: "Kinalabasan",
    resolved: "Naayos na ang problema",
    followUp: "Kailangan ng follow-up na visit",
    followUpNote: "Ano ang kailangan sa susunod",
    includeTime: "Ipakita ang oras sa site sa report ng kliyente",
    shareContact: "Ipakita sa kliyente ang mobile number ko",
    shareContactHint: "Naka-off bilang default. Para sa visit na ito lang.",
    method: "Paraan ng pirma",
    type: "I-type ang pangalan",
    draw: "Gumuhit",
    typedLabel: "I-type ng kliyente ang buo niyang pangalan",
    nameLabel: "Buong pangalan ng kliyente",
    titleLabel: "Posisyon sa trabaho (opsyonal)",
    previewEmpty: "Lalabas dito ang pangalan",
    padLabel: "Lagayan ng pirma. Gamitin ang I-type ang pangalan kung hindi ka makaguhit.",
    padHint: "Hindi makaguhit? Gamitin ang I-type ang pangalan.",
    agree: "Kinukumpirma kong ginawa ang trabahong nasa itaas.",
    errors: { typedName: "Hilingin sa kliyente na i-type ang buo niyang pangalan.", name: "I-type ang buong pangalan ng kliyente.", image: "Kailangang pumirma ng kliyente sa kahon, o gamitin ang I-type ang pangalan.", agree: "Kinukumpirma ng kliyente ang trabaho sa pag-tick ng kahon." },
    submit: "Pumirma ang kliyente at kumpletuhin",
    remote: "Magpadala na lang ng remote sign-off link",
    saveFirst: "Hindi ma-save ang report. Tingnan ang koneksyon mo at subukan ulit.",
    completed: "Nakumpleto ang {{visit}}",
  },
  done: {
    title: "Tapos na",
    heading: { completed: "Nakumpleto ang visit", cannot_complete: "Natapos ang visit: hindi natapos ang trabaho", no_access: "Natapos ang visit: walang access", on_site: "Isinasagawa ang visit", scheduled: "Naka-schedule ang visit", dispatched: "Papunta na", proposed: "Naghihintay ng oras", cancelled: "Kinansela ang visit" },
    completedBody: "Nagawa na ang report para sa {{visit}} at hawak na ito ng opisina.",
    onSite: "Nasa site",
    checklist: "Checklist",
    parts: "Piyesa",
    recorded_one: "{{count}} ang naitala",
    recorded_other: "{{count}} ang naitala",
    photos: "Litrato",
    signedBy: "Pumirma",
    remotePending: "Naipadala ang remote link",
    openReport: "Buksan ang report (PDF)",
    notYet: "Tapusin ang pirma para makumpleto ang visit.",
    finish: "Pumunta sa pirma",
  },
  errors: {
    report_incomplete: "Ilarawan ang ginawang trabaho at sagutin ang bawat item sa checklist bago kumpletuhin.",
    report_locked: "Naisumite na ang report at hindi na ito mababago.",
    visit_ended: "Tapos na ang visit na ito kaya hindi na ito mababago.",
    visit_transition: "Hindi maaaring lumipat ang visit sa hakbang na iyon mula sa kinalalagyan nito.",
    visit_not_yours: "Hindi naka-assign sa iyo ang visit na ito.",
    already_checked_in: "Naka-check in ka na sa visit na ito.",
    already_checked_out: "Naka-check out ka na sa visit na ito.",
    not_on_site: "Mag-check in muna bago mag-report mula sa site.",
    reason_needed: "Sumulat ng dahilang may kahit 3 character.",
    photo_not_image: "Dapat larawan ang file ng litrato.",
    beyond_contract: "Lampas sa kontrata ang visit na ito. Ang opisina ang magpapasya kung paano ito bibilangin.",
    forbidden: "Hindi magagawa ng role mo iyon sa telepono.",
  },
} as const;
